import UserLogin from '@/views/User/Login'
import PasswordReset from '@/views/User/PasswordReset'

export default [
    {
        path: '/login',
        name: 'userLogin',
        component: UserLogin,
        meta: {
            title: 'Logowanie',
            menuRendered: false,
            requiresVisitor: true,
        }
    },
    {
        path: '/password-reset',
        name: 'password-reset',
        component: PasswordReset,
        meta: {
            title: 'Reset hasła',
            menuRendered: false,
            requiresVisitor: true,
        }
    },
]
